// extracted by mini-css-extract-plugin
export default {"Icon":"ProcedureCard_Icon__zgYuA","ProcedureCard":"ProcedureCard_ProcedureCard__dzn0G"};